/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoContattoUpdateDTO
 */
export interface TipoContattoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoContattoUpdateDTO
     */
    descrizione: string;
}

/**
 * Check if a given object implements the TipoContattoUpdateDTO interface.
 */
export function instanceOfTipoContattoUpdateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function TipoContattoUpdateDTOFromJSON(json: any): TipoContattoUpdateDTO {
    return TipoContattoUpdateDTOFromJSONTyped(json, false);
}

export function TipoContattoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoContattoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
    };
}

export function TipoContattoUpdateDTOToJSON(value?: TipoContattoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
    };
}

